import React from "react";
import { Container, ProgressBar } from "react-bootstrap";

interface ProgressProps {
  bioDataStatus: string | null;
  testTakenStatus: string | null;
  interviewStatus: string | null;
}

const StepProgress = ({ bioDataStatus, testTakenStatus, interviewStatus }: ProgressProps) => {
  // Calculate progress dynamically
  const getProgress = () => {
    if (interviewStatus === "passed") return 100;
    if (testTakenStatus === "passed") return 66;
    if (bioDataStatus === "verified") return 33;
    return 0; // Start at 0%
  };

  return (
    <Container className="my-5 text-center">

      <div className="position-relative">
        {/* Progress Bar */}
        <ProgressBar now={getProgress()} className="mb-4" style={{ height: "8px", marginTop: "20px" }} />

        {/* Step Indicators */}
        <div className="d-flex justify-content-between position-absolute w-100" style={{ top: "-15px", left: "0" }}>
          <div className="text-left">
            <div
              className="rounded-circle d-inline-block"
              style={{
                width: "24px",
                height: "24px",
                backgroundColor: getProgress() >= 0 ? "#28a745" : "#ccc",
                border: "2px solid white",
              }}
            />
            <p className="mt-2" style={{ fontSize: "14px" }}>Biodata</p>
          </div>

          <div className="text-center">
            <div
              className="rounded-circle d-inline-block"
              style={{
                width: "24px",
                height: "24px",
                backgroundColor: getProgress() >= 33 ? "#28a745" : "#ccc",
                border: "2px solid white",
              }}
            />
            <p className="mt-2" style={{ fontSize: "14px" }}>Test</p>
          </div>

          <div className="text-right">
            <div
              className="rounded-circle d-inline-block"
              style={{
                width: "24px",
                height: "24px",
                backgroundColor: getProgress() >= 66 ? "#28a745" : "#ccc",
                border: "2px solid white",
              }}
            />
            <p className="mt-2" style={{ fontSize: "14px" }}>Interview</p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default StepProgress;
